export default "__VITE_ASSET__Bd8jgMdu__"